module.exports = __webpack_public_path__ + "static/media/TelaRojaPcMin.6b132611.jpg";